import { ClipboardCopyIcon, PauseIcon, PlayIcon } from '@radix-ui/react-icons';
import { Flex, TextField } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonCallout } from 'components/common/callouts';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonFormGrid } from 'components/common/form/grid';
import { CommonSwitchInput } from 'components/common/form/switch';
import { SettingRow } from 'components/common/settings-dialog/row';
import { t } from 'i18next';
import ReactMarkdown from 'react-markdown';

interface IProps {
  manual: boolean;
  onToggleManual: (v: boolean) => void;

  paused: boolean;
  onTogglePaused: (v: boolean) => void;

  lastKey: string;
}

export const AccessoriesSectionManualForm = (props: IProps) => {
  return (
    <ErrorBoundary identifier="AccessoriesSectionManualForm">
      <SettingRow
        header="settings.manual-mapping-controls"
        description={t('settings.manual-mapping-controls-msg')}
        input={
          <Flex justify="end">
            <CommonSwitchInput
              id="remote-control-manual-mode"
              defaultChecked={props.manual}
              onCheckedChange={props.onToggleManual}
            />
          </Flex>
        }
      />

      {props.manual && (
        <SettingRow
          separatorBefore
          header="settings.key-listener"
          description={
            <ReactMarkdown children={t('settings.key-listener-msg')} />
          }
          input={
            <CommonFormGrid columns={1}>
              <TextField.Root
                placeholder={
                  props.lastKey ?? t('settings.press-any-key').toString()
                }
                autoCapitalize="off"
                autoCorrect="off"
                autoComplete="off"
                readOnly
              >
                <TextField.Slot className="cursor-pointer" side="right">
                  {props.paused ? (
                    <PlayIcon onClick={() => props.onTogglePaused(false)} />
                  ) : (
                    <PauseIcon onClick={() => props.onTogglePaused(true)} />
                  )}
                </TextField.Slot>
                <TextField.Slot className="cursor-pointer" side="right">
                  <ClipboardCopyIcon
                    onClick={() => {
                      if (!props.lastKey) {
                        return;
                      }

                      // pause so the user doesn't have to pause or hide the manual form
                      props.onTogglePaused(true);

                      navigator.clipboard.writeText(props.lastKey).then(() =>
                        NotifyHelper.success({
                          message_md: t('common.copied-x-to-clipboard-msg', {
                            x: props.lastKey,
                          }),
                        })
                      );
                    }}
                  />
                </TextField.Slot>
              </TextField.Root>

              <CommonCallout
                text={t('settings.pause-key-listener-msg').toString()}
              />
            </CommonFormGrid>
          }
        />
      )}
    </ErrorBoundary>
  );
};
